import GameScreen from './GameScreen';

export default GameScreen;
